<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="ui-inputgroup">
  <bs-autocomplete
    [ngModel]="selected"
    (ngModelChange)="selected = $event"
    [items]="results"
    [dropdown]="true"
    [requireSelection]="true"
    [disabled]="disabled"
    [placeholder]="placeholder ?? ''"
    [displayWith]="getDisplayName"
    [compareWith]="compareByUuid"
    (queryChange)="onQueryChange($event)"
    (selected)="onSelectItem($event)"
    (cleared)="onClear()" data-testid="selected-autocomplete">
    <ng-template bsItem let-item>
      <div>{{ item.personDTO?.name }}</div>
    </ng-template>
  </bs-autocomplete>
</div>


